import { connect } from 'react-redux';

import ThankYou from './view';

export default connect(
  state => ({
    donorResultNotSaved: state.transient.donorResultNotSaved,
    mode: state.application.mode,
    uploadMediaLoading: state.transient.uploadMediaLoading
  }),
  {}
)(ThankYou);
